import { GeaoPaths } from "./GeaoPaths";

const PrincipalFlowVerticalStepperElements = Object.freeze([
    {
        title: "Personal",
        items: [
            {
                text: "Personal Information",
                trackingId: "PersonalInformation",
                path: GeaoPaths.PrincipalPersonalInformation
            },
            {
                text: "Background Information",
                trackingId: "BackgroundInformation",
                path: GeaoPaths.PrincipalBackgroundInformation
            }
        ]
    },
    {
        title: "Agency",
        items: [
            {
                text: "Office Information",
                trackingId: "OfficeInformation",
                path: GeaoPaths.PrincipalAgencyOfficeInformation
            },
            {
                text: "Employee Information",
                trackingId: "EmployeeInformation",
                path: GeaoPaths.PrincipalAgencyEmployeeInformation
            },
            {
                text: "Financial Information",
                trackingId: "FinancialInformation",
                path: GeaoPaths.PrincipalAgencyFinancialInformation
            },
            {
                text: "Additional Information",
                trackingId: "AdditionalInformation",
                path: GeaoPaths.PrincipalAgencyAdditionalInformation
            }
        ]
    },
    {
        title: "Banking",
        items: [
            {
                text: "Banking Information",
                trackingId: "BankingInformation",
                path: GeaoPaths.PrincipalBankingInformation
            },
            {
                text: "W-9 Tax Form",
                trackingId: "W9TaxForm",
                path: GeaoPaths.PrincipalW9TaxForm
            }
        ]
    },
    {
        title: "Errors & Omissions (E&O)",
        items: [
            {
                text: "E&O Policy Information",
                trackingId: "EoPolicyInformation",
                path: GeaoPaths.PrincipalErrorsAndOmissions
            }
        ]
    },
    {
        title: "Finalize",
        items: [
            {
                text: "Review, Sign and Submit",
                trackingId: "ReviewSignAndSubmit",
                path: GeaoPaths.PrincipalReviewAndSign
            },
            {
                text: "Application Submitted",
                trackingId: "ApplicationSubmitted",
                path: GeaoPaths.PrincipalApplicationSubmitted
            }
        ]
    }
]);

export default PrincipalFlowVerticalStepperElements;